import { connect } from 'react-redux';
import { StoreState } from '../../../../reducers';

import MediaItem from '../../../../components/Editor/MediaEditor/MediaItem';
import * as helpers from '../../utils/helpers';
import { EditableType, EditorType } from '../../constants';

const mapStateToProps = (state: StoreState, ownProps) => {
	const {
		editor: {
			type: editorType,
			editableMedia,
		},
		galleryInfos: { config },
	} = state;
	const { tempGId: resourceId } = helpers.getClientAndResourceIds();
	const { page, id, canDragAndResize } = ownProps;
	const {
		type,
		defaultLink,
		driveLink,
		externalLink,
		isExternalLinkActive,
	} = editableMedia[page][id];
	const link = (isExternalLinkActive ? externalLink : driveLink) || defaultLink as string;
	const isDefaultMedia = isExternalLinkActive ? externalLink === defaultLink : !driveLink;
	let src = helpers.getResourceUrl(link, config, resourceId, editorType === EditorType.HTML);

	if (type === EditableType.video) {
		const isDefaultVideoInHtmlEditor = editorType === EditorType.HTML && isDefaultMedia;
		src = isExternalLinkActive
			? helpers.getYoutubeVideoCover(src)
			: helpers.getVideoCover(src, isDefaultVideoInHtmlEditor);
	}

	if (type === EditableType.animation) {
		src = helpers.getAnimationCover(src);
	}

	return {
		...editableMedia[page][id],
		canDragAndResize,
		editorType,
		src,
		isDefaultMedia,
	};
};

export default connect(mapStateToProps)(MediaItem);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/MediaEditor/MediaItem/index.tsx